<div class="flex h-[calc(100dvh)] flex-col">
  <div class="flex h-14 items-center justify-start pl-3">
    <!--     <button (click)="hideSideBar()">
      <img src="icons/collapse-side-bar.svg" class="h-7" />
    </button> -->
  </div>
  <div class="flex h-full flex-1 flex-col overflow-hidden px-4 pb-5 pt-2">
    <ng-content />
  </div>
</div>
